import Sandbox from '@components/Sandbox';
import { useTeamsData } from '@lib/hooks/useTeamsData';
import { createIpaPlatform } from '@services/youtube-platform.service';
import { useEffect, useState } from 'react';

export default function SandboxPage({
  platform,
  templateId,
  interaction
}) {
  const [platformId, setPlatformId] = useState(null);
  const { teamContext, initTeam } = useTeamsData((s) => ({ teamContext: s.teamContext, initTeam: s.initTeam }));

  useEffect(() => {
    initTeam();
  }, []);

  const findOrCreateSandboxPlatform = async () => {
    const res = await createIpaPlatform({ userId: teamContext?.oid });
    setPlatformId(res.entity[0].platform_id);
  };

  useEffect(() => {
    if (teamContext?.oid) {
      findOrCreateSandboxPlatform();
    }
  }, [teamContext]);

  if (!platformId) return null;

  return <Sandbox
    platform={platform}
    platformId={platformId}
    interaction={interaction}
    templateId={templateId}
  />;
}

export const getServerSideProps = async ({ query }) => {
  try {
    const { platform = 'zoom', interaction = 0, templateId = '54e37f08-2ae7-4a32-ac8c-ba60fe5d5d0b' } = query;

    return {
      props: {
        platform,
        interaction,
        templateId
      }
    };
  } catch (error) {
    return {
      redirect: {
        destination: '/'
      }
    };
  }
};
